// Build a product by adding the correct CSS classes and attributes to the HTML elements

import { getImagesByColor } from './images';
import { handleize } from '../helper/functions';

export async function buildProducts(container, filters_to_check) {

    const products = container.querySelectorAll('.js-product:not(.built)')

    for (const product of products) {
        await buildProduct(product, filters_to_check);
    }

}

// Main function - Build the product page

export async function buildProduct(el, filters_to_check) {

    if (el.getAttribute("handle") || el.dataset.handle) {

        const handle = el.dataset.handle ? el.dataset.handle : el.getAttribute("handle");
        let product = await fetch(`${window.Shopify.routes.root}products/${handle}.js`)
        .then(response => response.json())
        .then(data => { return data });

        // #LCTEST
        if (product.handle === 'lingeriecycle') {
            el.closest('.js-plp-product').style.display = 'none';
        }
        // #ENDLCTEST

        // #BABTEST
        if (product.handle === 'bundle-test-3-pack') {
            el.closest('.js-plp-product').style.display = 'none';
        }
        if (product.handle === 'bundle-test-5-pack') {
            el.closest('.js-plp-product').style.display = 'none';
        }
        // #ENDBABTEST

        var show_on_filter = true;
        var sale_tag = product.tags.includes('Sale');
        var daily_lace_plp = document.querySelector('.js-daily-lace');

        // console.log("API", product);

        if (filters_to_check === undefined) {
            filters_to_check = {
                color: [],
                size: []
            };
        }

        if (sale_tag && daily_lace_plp === null && filters_to_check.size.length > 0) {

            let size_option = product.options.find(e => (e.name.toLowerCase()) === 'size');

            if (size_option) {

                let size_index = 'option' + size_option.position;

                let size_availability = {};
                let in_stock_sizes = [];

                for (let i = 0, limit = filters_to_check.size.length; i < limit; i++) {
                    size_availability[filters_to_check.size[i].toUpperCase()] = [];
                }

                for (let i = 0, limit = product.variants.length; i < limit; i++) {
                    let variant = product.variants[i];
                    if (size_availability[variant[size_index]]) {
                        size_availability[variant[size_index]].push(variant.available);
                    }
                }

                for (let size in size_availability) {
                    if (size_availability[size].includes(true)) {
                        in_stock_sizes.push(size);
                    }
                }

                if (in_stock_sizes.length === 0) {
                    el.closest('.js-plp-product').style.display = 'none';
                    show_on_filter = false;
                }
            }
        }

        if (show_on_filter) {
            // get all the images for the product
            // let images = getImages(product)

            // let images = old_product.product.images;

            var images;

            // get the option for color
            let color_option = product.options.find(e => (e.name.toLowerCase()) === 'color');

            // // get the option index for color
            // let option_index = 'option' + color_option.position;

            // create a colors selector element
            let colors_selector = ''

            // if color is an option, create swatches
            if (color_option) {

                // get the option index for color
                let color_index = 'option' + color_option.position;

                let images_obj = getImagesByColor(product, color_index);

                let variants_to_check;

                // if color filters are applied show all color swatches
                if (sale_tag && filters_to_check.color.length === 0) {
                    variants_to_check = getInStockColors(product, color_index);

                    if (variants_to_check.length === 0) {
                        images = product.images;
                    }
                } else {
                    // get the variants, one of each color
                    variants_to_check = getOneVariantOfEachColor(product, color_index);
                }

                // // if color filters are applied show all color swatches
                // if (filters_to_check.color.length > 0) {
                //     // get the variants, one of each color
                //     variants_to_check = getOneVariantOfEachColor(product, color_index);
                //     console.log('getOneVariantOfEachColor', variants_to_check);
                // } else {
                //     // get only in stock color variants
                //     variants_to_check = getInStockColors(product, color_index);

                //     // console.log('getInStockColors', variants_to_check);

                //     if (variants_to_check.length === 0) {
                //         images = product.images;
                //     }
                // }

                let index = 0;
                for (let variant of variants_to_check) {
                    if (images === undefined) {
                        images = images_obj[variant[color_index]];
                    }

                    let checked = (index == 0) ? 'checked' : '';

                    let color_swatch = `
                        <div class='color-item mr-3 mb-3'>
                            <input type='radio' name='${product.id}-color' data-type='radio-color' data-color='${variant[color_index]}' value='${variant.id}' data-product_id='${product.id}' id='option-${variant.id}' ${checked} />
                            <label class='text-0px' for='option-${variant.id}' data-option='${handleize(variant[color_index])}'>${variant[color_index]}</label>
                        </div>`;
                    colors_selector = colors_selector + color_swatch;

                    index++;

                    if (index == 5) {
                        if ((variants_to_check.length - index) != 0) {
                            colors_selector = colors_selector + `<span class='text-13px tracking-0_3px text-gray mb-2'>+${variants_to_check.length - 5}</span>`;
                        }
                        break;
                    }
                }

            } else {
                images = product.images;
            }

            let compare_at_price = product.variants[0].compare_at_price / 100;
            let price = product.variants[0].price / 100;
            let currency = document.querySelector('.js-currency').dataset.currency;

            let price_with_currency = '$' + price;
            let compare_at_price_with_currency = '$' + compare_at_price;
            if (window.Shopify.routes.root.length > 1) {
              price_with_currency = currency.replace(/{{[\s\S]+}}/g, price);
              compare_at_price_with_currency = currency.replace(/{{[\s\S]+}}/g, compare_at_price);
            }

            let compare_at_price_html = (isNaN(compare_at_price) || (compare_at_price == 0)) ? '' : ('<span class="mr-1 line-through text-gray whitespace-nowrap js-variant-compare-at-price-' + product.id + '">' + compare_at_price_with_currency + '</span>')
            let price_html = price ? ('<span class="whitespace-nowrap js-variant-price-' + product.id + '">' + price_with_currency + '</span>') : ''

            // const metafields = {
            //     best_seller: el.dataset.best_seller,
            //     sale: el.dataset.sale,
            //     final_sale: el.dataset.final_sale,
            //     new_prod: el.dataset.new
            // }

            // let metafield = Object.keys(metafields).find(key => metafields[key] === "1");

            // let metafield_ref = {
            //     "best_seller": {
            //         "title": "Best Seller",
            //         "bg": "bg-brown"
            //     },
            //     "sale": {
            //         "title": "Sale",
            //         "bg": "bg-peach"
            //     },
            //     "final_sale": {
            //         "title": "Final<br/>Sale",
            //         "bg": "bg-orange"
            //     },
            //     "new_prod": {
            //         "title": "New",
            //         "bg": "bg-white border-blue border-solid text-blue"
            //     }
            // }


            // let bg = (metafield) ? metafield_ref[metafield].bg : ''
            // let title = (metafield) ? metafield_ref[metafield].title : ''

            // HOTFIX for undefined images NEED TO REFACTOR
            if (images === undefined) {
              images = product.images;
            }

            let imgFileType = '.jpg',
                images1 = images[0],
                images2 = images[1];

            var img1 = '',
                img2 = '';

            if (images1) {

                if (images1.includes('.png')) {
                    imgFileType = '.png';
                }

                let prodImg1 = images1.replace('https:','');

                let src1Desktop = prodImg1.replace(imgFileType, `_x1600${imgFileType}`),
                    src1Mobile = prodImg1.replace(imgFileType, `_x900${imgFileType}`);

                img1 = `
                    <picture>
                        <source data-image="1" data-src_mobile="${product.id}" srcset="${src1Mobile}" media="(max-width: 767px)">
                        <source data-image="1" data-src_desktop="${product.id}" srcset="${src1Desktop}" media="(min-width: 768px)">
                        <img loading="lazy"
                                src="${prodImg1}"
                                class="w-full h-full object-cover inset-0 absolute"
                                data-image="1"
                                data-product_id="${product.id}"
                                alt="">
                    </picture>
                `;
            } else {
                img1 = `
                <picture>
                    <source data-image="1" data-src_mobile="${product.id}" srcset="" media="(max-width: 767px)">
                    <source data-image="1" data-src_desktop="${product.id}" srcset="" media="(min-width: 768px)">
                    <img loading="lazy"
                            src=""
                            class="w-full h-full object-cover inset-0 absolute"
                            data-image="1"
                            data-product_id="${product.id}"
                            alt=""
                            style="display:none;">
                </picture>
            `;
            }

            if (images2) {

                if (images2.includes('.png')) {
                    imgFileType = '.png';
                } else {
                    imgFileType = '.jpg';
                }

                let prodImg2 = images2.replace('https:','');

                let src2Desktop = prodImg2.replace(imgFileType, `_x1600${imgFileType}`),
                    src2Mobile = prodImg2.replace(imgFileType, `_x900${imgFileType}`);

                img2 = `
                    <picture>
                        <source data-image="2" data-src_mobile="${product.id}" srcset="${src2Mobile}" media="(max-width: 767px)">
                        <source data-image="2" data-src_desktop="${product.id}" srcset="${src2Desktop}" media="(min-width: 768px)">
                        <img loading="lazy"
                            src="${images2}"
                            class="w-full h-full object-cover inset-0 absolute opacity-0 hover:opacity-100 transition duration-300"
                            data-image="2"
                            data-product_id="${product.id}"
                            alt="">
                    </picture>
                `;
            } else {
                img2 = `
                    <picture>
                        <source data-image="2" data-src_mobile="${product.id}" srcset="" media="(max-width: 767px)">
                        <source data-image="2" data-src_desktop="${product.id}" srcset="" media="(min-width: 768px)">
                        <img loading="lazy"
                            src=""
                            class="w-full h-full object-cover inset-0 absolute opacity-0 hover:opacity-100 transition duration-300"
                            data-image="2"
                            data-product_id="${product.id}"
                            alt=""
                            style="display:none;">
                    </picture>
                `;
            }

            const url = (el.dataset.url) ? el.dataset.url : `${window.Shopify.routes.root}products/${product.handle}`

            const cta = (typeof el.dataset.cta != 'undefined') ? `<div class='block mt-4 text-13px font-bold underline'><a href='${url}'>Shop Now</a></div>` : ``

            let promo_message = '';
            let promos = document.querySelectorAll('.js-promotext');
            let tag_array = product.tags.map(item => item.toLowerCase());

            promos.forEach((elem) => {
              if (tag_array.includes(elem.dataset.tag))  {
                promo_message = `<p class="text-13px" style="color:${(elem.dataset.color)};">${(elem.textContent)}</p>`;
              }
            });

            let item = `<div>
                            <a href="${url}" class="block relative pt-135 w-full h-0 mb-4 border border-beige">
                                ${img1}
                                ${img2}
                                <div class='js-loader absolute z-10 bg-white bg-opacity-20 w-full h-full inset-0'><div class="lds-roller absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
                            </a>

                            <a href="${url}" class="block text-13px">
                                <span class="block font-bold">${product.title}</span>
                                <div class="flex flex-wrap">
                                  ${compare_at_price_html}${price_html}
                                </div>
                            </a>

                            ${promo_message}

                            <div class="flex flex-wrap items-center mt-4" role="radiogroup" aria-labelledby="radiogroup-${product.id}">
                                <p id="radiogroup-${product.id}" class="screen-reader-only">Color swatches for ${product.title}</p>
                                ${colors_selector}
                            </div>
                            ${cta}
                        </div>`;

            if (daily_lace_plp) {

                item = `<div>
                            <a href="${url}" class="block relative pt-135 w-full h-0 mb-4">
                                ${img1}
                                ${img2}
                                <div class='js-loader absolute z-10 bg-white bg-opacity-20 w-full h-full inset-0'><div class="lds-roller absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
                            </a>

                            <div class="lg:pl-6">
                                <a href="${url}" class="block text-13px">
                                    <span class="block font-bold">${product.title}</span>
                                    <div class="flex flex-wrap">
                                        ${compare_at_price_html}${price_html}
                                    </div>
                                </a>

                                ${promo_message}

                                <div class="flex flex-wrap items-center mt-4" role="radiogroup" aria-labelledby="radiogroup-${product.id}">
                                    <p id="radiogroup-${product.id}" class="screen-reader-only">Color swatches for ${product.title}</p>
                                    ${colors_selector}
                                </div>
                                ${cta}
                            </div>
                        </div>`;
            }

            // add the products to the DOM before adding the event listeners
            // el.insertAdjacentHTML('beforeend', item)

            el.innerHTML = item

            el.classList.add('built')

            // set the selectors
            setSelectors(product, el)
        }
    }
}

// Get the first variant of each color
function getOneVariantOfEachColor(product, option_index) {

    const result = [];
    const map = new Map();

    for (const item of product.variants) {
        if(!map.has(item[option_index])){
            map.set(item[option_index], true);
            result.push(item);
        }
    }

    return result;
}

// Get variant stock for each color
function getInStockColors(product, color_index) {

    var variant_stock = [];
    var in_stock_colors = [];

    for (let i = 0, limit = product.variants.length; i < limit; i++) {

        let variant = product.variants[i];

        if (i === limit - 1) {

            variant_stock.push(variant.available);

            if (variant_stock.includes(true)) {
                in_stock_colors.push(variant);
            }

            break
        }

        if (product.variants[i][color_index] === product.variants[i+1][color_index]) {
            variant_stock.push(variant.available);
        } else {

            variant_stock.push(variant.available);

            if (variant_stock.includes(true)) {
                in_stock_colors.push(variant);
            }

            variant_stock = [];
        }
    }

    return in_stock_colors;
}

// Set the srcset for the images
async function setSelectors(prod, el) {

  let images = el.querySelectorAll('[data-image]')

  for (let image of images) {
      image.onload = function () {
          el.querySelector('.js-loader').style.display = 'none'
      }
  }

  let radios = (prod) ? el.querySelectorAll(`[data-type="radio-color"][data-product_id="${prod.id}"]`): []

  for (let radio of radios) {
    if (!radio.classList.contains('has-listener')) {
      radio.classList.add('has-listener')
    }

    radio.addEventListener('change', async () => {

      let variant_id = parseInt(radio.value)

      // change the prices

      let variants = prod.variants
      let selected = variants.find(e => e.id === variant_id)

      let currency = document.querySelector('.js-currency').dataset.currency;

      let price_with_currency = '$' + (selected.price / 100);
      let compare_at_price_with_currency = '$' + (selected.compare_at_price / 100);
      if (window.Shopify.routes.root.length > 1) {
        price_with_currency = currency.replace(/{{[\s\S]+}}/g, (selected.price / 100));
        compare_at_price_with_currency = currency.replace(/{{[\s\S]+}}/g, (selected.compare_at_price / 100));
      }

      el.querySelector('.js-variant-price-' + prod.id).innerHTML = price_with_currency;

      if (el.querySelector('.js-variant-compare-at-price-' + prod.id)) {
        if (selected.compare_at_price) {
          el.querySelector('.js-variant-compare-at-price-' + prod.id).innerHTML = compare_at_price_with_currency;
        } else {
          el.querySelector('.js-variant-compare-at-price-' + prod.id).innerHTML = '';
        }
      }

      // change the images
      let images_obj = getImagesByColor(prod);

      let images = images_obj[radio.dataset.color];

      if (images) {

          // let srcset = buildSrcset(images);

          el.querySelector('.js-loader').style.display = 'block'

          let imgFileType = '.jpg';

          if (images[0].includes('.png')) {
              imgFileType = '.png';
          }

          if (images[0]) {
              let prodImg1 = images[0].replace('https:',''),
                  src1Desktop = prodImg1.replace(imgFileType, `_x1600${imgFileType}`),
                  src1Mobile = prodImg1.replace(imgFileType, `_x900${imgFileType}`);

              el.querySelector(`[data-image="1"][data-product_id="${prod.id}"]`).src = images[0];
              el.querySelector(`[data-image="1"][data-src_desktop="${prod.id}"]`).setAttribute('srcset', src1Desktop);
              el.querySelector(`[data-image="1"][data-src_mobile="${prod.id}"]`).setAttribute('srcset', src1Mobile);
          }

          if (images[1]) {
              let prodImg2 = images[1].replace('https:',''),
                  src2Desktop = prodImg2.replace(imgFileType, `_x1600${imgFileType}`),
                  src2Mobile = prodImg2.replace(imgFileType, `_x900${imgFileType}`);

              el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).src = images[1];
              el.querySelector(`[data-image="2"][data-src_desktop="${prod.id}"]`).setAttribute('srcset', src2Desktop);
              el.querySelector(`[data-image="2"][data-src_mobile="${prod.id}"]`).setAttribute('srcset', src2Mobile);
              el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).style.display = '';
          } else {
              el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).style.display = 'none';
          }
      }

    })
  }
}
